var React = require('react');

function IconZendesk (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#000000;}.cls-2{fill:#000000;}")),React.createElement("title",{"key":1},"icon-support"),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":2},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},[React.createElement("rect",{"className":"cls-1","x":"-8.77","y":"21.27","width":"71.1","height":"35.55","transform":"translate(-18.07 54.2) rotate(-74.21)","key":0}),React.createElement("rect",{"className":"cls-2","x":"57.63","y":"38.37","width":"35.55","height":"35.55","transform":"matrix(-0.96, 0.27, -0.27, -0.96, 163.25, 89.66)","key":1})]))]);
}

IconZendesk.defaultProps = {"viewBox":"0 0 97.35 78.09"};

module.exports = IconZendesk;

IconZendesk.default = IconZendesk;
